<template>
  <ConfirmationModalRoot
    v-model="isOpen"
    :prevent-close-on-backdrop-click="true"
    @close="onClose"
  >
    <template #default>
      <ConfirmationModalTitle>
        {{ t("serviceWorker.updateAvailable.title") }}
      </ConfirmationModalTitle>

      <ConfirmationModalBody>
        {{ t("serviceWorker.updateAvailable.message") }}
      </ConfirmationModalBody>
    </template>

    <template #actions>
      <ButtonV2
        variant="primary"
        size="sm"
        :disabled="props.isUpdating"
        @click="onRefresh"
      >
        <Icon v-if="props.isUpdating" icon="eos-icons:loading" class="mr-2" />
        {{ t("serviceWorker.updateAvailable.reload") }}
      </ButtonV2>
    </template>
  </ConfirmationModalRoot>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import ConfirmationModalRoot from "@/components/ui/modal/confirmation-modal/confirmation-modal-root.vue";
import ConfirmationModalTitle from "@/components/ui/modal/confirmation-modal/confirmation-modal-title.vue";
import ConfirmationModalBody from "@/components/ui/modal/confirmation-modal/confirmation-modal-body.vue";
import ButtonV2 from "@/components/ui/button/button-v2.vue";
import { Icon } from "@iconify/vue";

interface Props {
  needRefresh: boolean;
  offlineReady: boolean;
  updateServiceWorker: () => Promise<void>;
  isUpdating: boolean;
  close: () => void;
}

const props = defineProps<Props>();
const { t } = useI18n();

const isOpen = ref(false);

watch(
  () => props.needRefresh,
  (value) => {
    isOpen.value = value;
  },
  { immediate: true },
);

async function onRefresh() {
  await props.updateServiceWorker();
}

function onClose() {
  props.close();
}
</script>

<style scoped></style>
